export const userViewsCheckoutConfirmation = () => ({
  type: 'View checkout confirmation page',
});

export const userClickedViewAccount = () => ({
  type: 'Clicks View Account button',
});
